// Display name / short description of a licensable module from the billing
// catalog (`/api/billing/plan-pricing` → available_modules). The catalog
// stores Turkish names, so translate by module key and fall back to what the
// backend sent for modules this list doesn't know yet.
export const moduleDisplayName = (m, t) => {
  if (!m) return '';
  const fallback = m.display_name || m.name || m.key || '';
  return m.key ? t(`shared.moduleNames.${m.key}`, { defaultValue: fallback }) : fallback;
};

export const moduleDescription = (m, t) => {
  if (!m) return '';
  const fallback = m.description || '';
  return m.key ? t(`shared.moduleDescriptions.${m.key}`, { defaultValue: fallback }) : fallback;
};
